import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative min-h-[70vh] flex flex-col items-center justify-center text-center px-4 py-20">
      <span className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none">404</span>
      <h1 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-950">页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-600">你访问的页面不存在，可能已被移动或删除。</p>
      <p className="mt-1 text-xs text-foreground-500 font-mono break-all max-w-md">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="h-10 px-6 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium flex items-center gap-2 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i> 返回首页
        </Link>
        <Link
          to="/search"
          className="h-10 px-6 rounded-md bg-background-100 border border-background-300 hover:border-primary-400 text-foreground-900 text-sm font-medium flex items-center gap-2 transition-colors whitespace-nowrap"
        >
          <i className="ri-search-line"></i> 去搜索视频
        </Link>
      </div>
    </div>
  );
}